const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "مقدمة الشركة",
    "termsOfService": "شروط الخدمة",
    "privacyPolicy": "الخصوصية",
    "guaranteeOfRights": "كفالة الحقوق",
    "customerSupport": "خدمة العملاء",
    "cookiePolicy": "سياسة سجل التتبع",
    "declarationOfSafety": "إعلان ألأمن والتأمين",
    "youthProtectionPolicy": "سياية حماية القاصرين",
    "communityPolicy": "السياسة المجتمعية",
    "probability": "probability",
    "operationPolicy": "سياسة الاستخدام",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "الموافقة على خدمات NC",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "علامة إضافية وفقًا للقوانين المتعلقة باللعبة",
    "brandInformation": "معلومات العلامة التجارية",
    "copyright": "حقوق التأليف والنشر",
    "channelingInfo": "NC Co.، Ltd. هي شركة وسيطة لشركات التعامل التجاري بالمراسلة. هي تتوسط في توفير ألعاب داخل plaync وليست معنية بالتعامل التجاري بالمراسلة مباشرة.<br>جميع الالتزامات والمسؤوليات المتعلقة بتوفير الألعاب خاصة بشركات التعامل التجاري بالمراسلة، ونحن لا نتحمل مسؤولية أي مشاكل تنشأ فيما يتعلق بذلك."
  },
  "infoCS": {
    "businessInformation": "التحقق من المعلومات التجارية",
    "infoAddress": "اسم الشركة NC Co.، Ltd. الرئيس التنفيذي المشارك كيم تايك جين، وبارك بيونغ-مو، رقم تسجيل الأعمال 220-81-43000 E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1600-0020  الفاكس:+82-2-2186-3550",
    "pc": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1600-0020  الفاكس:+82-2-2186-3550",
    "ncfamilyzone": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1600-0020  الفاكس:+82-2-2186-3550",
    "other": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1600-0020  الفاكس:+82-2-2186-3550",
    "none": "",
    "infoEmail": "البريد الإلكتروني",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(ألعاب الكمبيوتر)/MobileCS@ncsoft.com/(ألعاب الجوال)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "عنوان",
    "jpGenre": "نوع",
    "jpPrice": "السعر",
    "jpPriceValue": "(مجاني (يحتوي على مشتريات داخل التطبيق",
    "jpOs": "نظام تشغيل المراسلات",
    "jpPlatform": "منصة",
    "jpDevelopedBy": "مطور/مشغل من طرف",
    "jpReleaseDay": "يوم الاصدار",
    "jpReleaseDayValue_LW": "4نوفمبر 2021"
  },
  "country": {
    "KR": "جمهورية كوريا الجنوبية",
    "TW": "تايوان",
    "RU": "روسيا",
    "MY": "ماليزيا",
    "SA": "المملكة العربية السعودية",
    "SG": "سنغافورة",
    "AE": "الإمارات العربية المتحدة",
    "ID": "أندونيسيا",
    "JP": "اليابان",
    "QA": "قطر",
    "TH": "تايلاند",
    "PH": "الفيليبين",
    "HK": "هونغ كونغ",
    "UA": "أوكرانيا",
    "BY": "بيلاروس",
    "LT": "ليتوانيا",
    "PL": "بولندا",
    "GR": "اليونان",
    "IL": "إسرائيل",
    "KW": "الكويت",
    "AT": "النمسا",
    "US": "الولايات المتحدة الأمريكية",
    "CA": "كندا",
    "DE": "ألمانيا",
    "GB": "بريطانيا",
    "FR": "فرنسا",
    "BR": "البرازيل",
    "IT": "إيطاليا",
    "ES": "إسبانيا",
    "CL": "تشيلي",
    "NO": "النرويج",
    "SE": "السويد",
    "IE": "أيرلندا",
    "PT": "البرتغال",
    "FI": "فنلندا",
    "DK": "الدنمارك",
    "CH": "سويسرا",
    "AR": "الأرجنتين",
    "PE": "بيرو",
    "MX": "المكسيك",
    "KZ": "كازاخستان",
    "UZ": "أوزبكستان",
    "AZ": "أذربيجان",
    "GE": "جورجيا",
    "MD": "مولدوفا",
    "AM": "أرمينيا",
    "MO": "ماكاو",
    "IN": "الهند",
    "PK": "باكستان",
    "NL": "هولندا",
    "RO": "رومانيا",
    "AU": "أستراليا",
    "TR": "تركيا",
    "EC": "الإكوادور",
    "CO": "كولومبيا",
    "ZA": "جنوب أفريقيا",
    "EG": "مصر",
    "NC": "Global"
  }
};

export default l10n;
